module.exports = __webpack_public_path__ + "media/components/maps/incidents/pins/Social Unrest-f05f7c1f63937a21712670b024e386b3.png";